import axios from "../requests/axios";
import routes from "../requests/routes";
import { v4 as uuid } from "uuid";

export const parseDate = (date) => {
  if (!date) return "";
  return new Date(date).toLocaleString().split(",")[0].replaceAll("/", "-");
};

export const normFile = (e) => (Array.isArray(e) ? e : e?.fileList || []);
export const rawFile = (f) => (f?.originFileObj ? f.originFileObj : f);

export const uploadOne = async (file, onProgress) => {
  const fd = new FormData();
  fd.append("image", file);

  const { data } = await axios.post(routes.uploadImage, fd, {
    onUploadProgress: (e) => {
      const total = e.total || file.size || 1;
      const pct = Math.min(95, Math.round((e.loaded * 95) / total));
      onProgress?.(pct);
    },
  });
  console.log("Upload response", data);
  const url =
    data?.url ??
    data?.location ??
    (Array.isArray(data?.image) ? data.image[0] : undefined);

  if (!url) throw new Error("Upload did not return a URL");
  return String(url);
};

export const uploadMany = async (
  fileList = [],
  onItemProgress,
  onOverallProgress
) => {
  if (!fileList.length) return [];

  // Track per-file progress to compute an overall average
  const progressMap = {};
  const updateOverall = () => {
    const vals = Object.values(progressMap);
    const avg =
      vals.length > 0
        ? Math.round(vals.reduce((a, b) => a + b, 0) / vals.length)
        : 0;
    onOverallProgress?.(avg);
  };

  const jobs = fileList.map((f) => {
    const file = rawFile(f);
    const uid = f?.uid || file?.name || Math.random().toString(36);
    return uploadOne(file, (pct) => {
      progressMap[uid] = pct;
      onItemProgress?.(uid, pct);
      updateOverall();
    });
  });

  const urls = await Promise.all(jobs); // ['url1','url2',...]
  console.log("Uploaded all", urls);
  onOverallProgress?.(95);
  return urls.flat(); // safety, in case any nested slips in
};

export const beforeUpload = (file) => {
  const isImage = /^image\/(png|jpe?g|webp|gif|avif)$/.test(file.type);
  if (!isImage) message.error("Only images are allowed (jpg/png/webp/gif)");
  const isLt5M = file.size / 1024 / 1024 < 5;
  if (!isLt5M) message.error("Image must be smaller than 5MB");
  return isImage && isLt5M;
};

const KEY = "aid";

export function getViewerId() {
  try {
    let id = localStorage.getItem(KEY);
    if (!id) {
      id = uuid();
      localStorage.setItem(KEY, id);
    }
    return id;
  } catch {
    // localStorage may be blocked; fall back to ephemeral
    return uuid();
  }
}
